export const loadDataset = async () => {
    try {
        const response = await fetch('data/hero-heroine-dataset-v1.json');
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error loading sample story:', error);
        return null;
    }
};